import React from 'react';
import { motion } from 'framer-motion';
import { PAIN_BLOCKS } from './salesData';
export function PainSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-284" data-mp="38wlv6wefoyjb">
      <div className="mx-auto max-w-3xl px-5" data-id="element-285" data-mp="2uy5nb24u51zl">
        <div className="text-center" data-id="element-286" data-mp="2uxdrprb8n49b">
          <h2 className="font-display text-[1.4rem] font-bold uppercase leading-tight text-charcoal sm:text-[2rem]" data-id="element-287" data-mp="2v0i0l1zneo6b">
            Sos odontólogo. Tenés consultorio.
            <span className="mt-1 block text-gold-deep" data-id="element-288" data-mp="2l6riceu479z2">
              Pero nadie te enseñó a hacerlo funcionar como un negocio.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-289" data-mp="2baoft7vcp9bl">
            En la facultad aprendiste a diagnosticar y a tratar. Nadie te enseñó a medir, convertir y
            cobrar mejor. Si alguna de estas situaciones te suena, no es falta de trabajo: es falta
            de sistema.
          </p>
        </div>

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-290" data-mp="27ae2tb955in8">
          {PAIN_BLOCKS.map((phrase, i) => <motion.li key={phrase} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex gap-2.5 rounded-xl border border-stone bg-sand px-4 py-3.5 last:sm:col-span-2" data-id="element-291" data-mp="3nlfjw7awku0o" data-mpi={i}>
              <span className="font-display text-xl font-bold leading-none text-gold/50" aria-hidden data-id="element-292" data-mp="38u6o1ggeqcf3">
                “
              </span>
              <p className="font-sans text-[0.86rem] leading-relaxed text-charcoal/80" data-id="element-293" data-mp="3iofe7xhytta3">{phrase}</p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-base font-bold uppercase leading-snug text-charcoal sm:text-xl" data-id="element-294" data-mp="2q59tdbh3lhwc">
          El problema no es cómo trabajás. Es que el consultorio todavía no está ordenado como
          negocio.
        </p>
      </div>
    </section>;
}